import React from 'react';
import {
  FiGitBranch,
  FiLayers,
  FiMail,
  FiBriefcase,
  FiFileText,
  FiUsers,
  FiRepeat,
  FiFlag,
  FiGrid,
  FiShield,
} from 'react-icons/fi';
import ProductTaskPricing from '../ProductTaskPricing/ProductTaskPricing';
import './ProductTaskContent.css';

const ProductTaskContent = () => {
  const sixBoxes = [
    { title: 'Manage Projects', description: 'Manage small, medium and large projects with multiple team members' },
    { title: 'Smart Tasks', description: 'Create personal or shared tasks and manage with reminders and daily updates.' },
    { title: 'Team Collaboration', description: 'Work together seamlessly with real-time updates, shared projects, and team communication.' },
    { title: 'Progress Tracking', description: 'Track combined status of Projects and Tasks. Generate Transaction statements.' },
    { title: 'Smart Reminders', description: 'Never miss a deadline with intelligent notifications and customizable reminder settings.' },
    { title: 'Secure & Private', description: 'Your data is protected with enterprise-grade security and privacy controls.' },
  ];

  const features = [
    { icon: <FiLayers />, text: 'Easy to create' },
    { icon: <FiGitBranch />, text: 'Branch/Department wise allocation' },
    { icon: <FiMail />, text: 'Email reminders' },
    { icon: <FiBriefcase />, text: 'Project management' },
    { icon: <FiFileText />, text: 'Transaction statements' },
    { icon: <FiUsers />, text: 'Group wise task assignment' },
    { icon: <FiRepeat />, text: 'Repeatable tasks' },
    { icon: <FiFlag />, text: 'Prioritized tasks' },
    { icon: <FiGrid />, text: 'Customized views' },
    { icon: <FiShield />, text: 'User role based access control' },
  ];

  return (
    <>
      {/* Six boxes from home page */}
      <section className="product-task-six-boxes">
        <div className="container">
          <div className="features-grid">
            {sixBoxes.map((box, index) => (
              <div key={index} className="feature-card">
                <h3>{box.title}</h3>
                <p>{box.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features list */}
      <section className="product-task-features">
        <div className="container">
          <h2 className="product-task-features-title">Features</h2>
          <ul className="product-task-features-list">
            {features.map((feature, index) => (
              <li key={index}>
                <span className="product-task-feature-icon">{feature.icon}</span>
                <span className='text-muted'>{feature.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Prices - Subscription details without Select, with Subscribe Now */}
      <ProductTaskPricing />
    </>
  );
};

export default ProductTaskContent;
